<template>
  <div class="about-us">
    <div class="about-us-top"></div>
    <div class="about-us-bottom"></div>
    <div class="about-contents">
      <div class="contents about-contents-img">
        <img :width="aboutTitleWidth" :src="aboutus.aboutTitle" />
      </div>
      <div class="contents about-contents-video">
        <template v-if="aboutus.video">
          <!-- <video
            :src="aboutus.video"
            controls="controls"
            :poster="aboutus.poster"
            ref="startvideo"
          ></video> -->

          <video-player
            class="video-player-box"
            ref="startvideo"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ready="playerReadied"
            :options="getplayerOptions(aboutus.video, aboutus.poster)"
          ></video-player>
          <img
            class="videoimg"
            @click="startvideo"
            v-if="ifstartvideo"
            src="/static/brand/pay.png"
          />
        </template>
        <template v-else-if="aboutus.poster">
          <img class="poster" :src="aboutus.poster" />
        </template>
      </div>
      <div class="contents about-contents-info">
        <p v-html="aboutus.info"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifstartvideo: true
    };
  },
  props: {
    aboutus: {
      type: Object,
      default: function() {
        return {};
      }
    },
    aboutTitleWidth: {
      type: String,
      default: "420px"
    }
  },

  methods: {
    startvideo() {
      this.ifstartvideo = false;
      if (this.$refs.startvideo.player.paused) {
        setTimeout(() => {
          this.$refs.startvideo.player.play();
        }, 200);
      } else {
        this.$refs.startvideo.player.pause();
        //console.log("暂停播放");
      }
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    playerReadied(player) {
      //   setTimeout(() => {
      //     if (!this.ifstartvideo) {
      //       this.$refs.startvideo.player.play();
      //     }
      //   }, 1000);
      // you can use it to do something...
      // player.[methods]
    },
    getplayerOptions(url, imgurl) {
      let playerOptions = {
        // videojs options
        muted: true,
        language: "zh-CN",
        preload: "auto",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: url
          }
        ],
        poster: imgurl
      };
      return playerOptions;
    }
  }
};
</script>

<style scoped>
/**关于我们 */
.about-us {
  position: relative;
  overflow: hidden;
}
.about-contents {
  text-align: center;
  position: relative;
  overflow: hidden;
}
.about-contents .about-contents-img {
  margin-top: 45px;
  margin-bottom: 60px;
  text-align: center;
}
.about-contents .about-contents-video,
.about-contents .about-contents-video video,
.about-contents .about-contents-video .video-player-box,
.about-contents .about-contents-video .video-player-box >>> .video-js,
.about-contents .about-contents-video .poster {
  width: 1104px;
  height: 621px;
  position: relative;
}
.video-player-box >>> .vjs-big-play-button {
  display: none;
}
.about-contents-video .videoimg {
  position: absolute;
  top: calc(50% - 48px);
  left: calc(50% - 48px);
  width: 96px;
  height: 96px;
  cursor: pointer;
  animation: animated-border 1.5s infinite;
  border-radius: 48px;
}
@keyframes animated-border {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
}
.about-contents .about-contents-info {
  width: 1104px;
  margin-bottom: 74px;
  margin-top: 50px;
  /* position:absolute;
        left:0;
        top:0; */
}
.about-contents .about-contents-info p {
  font-size: 16px;
  line-height: 40px;
  color: #666666;
  text-indent: 2em;
  text-align: left;
  letter-spacing: 0.045em;
}
.about-us-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 507px;
  color: #f3f5f7;
  /* background: url("/static/brand/aboutusbj.png") no-repeat; */
}
.about-us-bottom {
  width: 100%;
  height: 663px;
  position: absolute;
  left: 0;
  top: 507px;
  background: url("/static/brand/aboutusbj2.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/AboutUs.vue